let ListMultiSelector = (function () {

  let fct = function (options) {

    let _this = {
      containerSelector: undefined,
      tableSelector: undefined,
      selectedValuesInputSelector: undefined,
      actionsSelector: undefined,
      pageCheckboxSelector: undefined,

      checkedValues: [],

      events: {
        change: [],
        inited: []
      },

      get selectedInPageCount() {
        return _this.getSelectedInPageCount();
      },

      get availableInPageCount() {
        return _this.getRowsInPageCount();
      },

      /**
       * Obtenir le nombre d'entrées visible sur la table.
       */
      getRowsInPageCount: function () {
        let $checkboxes = $(_this.tableSelector).find(".selector-element-checkbox");
        return $checkboxes.length;
      },

      /**
       * Obtenir le nombre d'éléments sélectionnés qui sont sur la table présentement.
       */
      getSelectedInPageCount: function () {
        let $checkboxes = $(_this.tableSelector).find(".selector-element-checkbox:checked");
        return $checkboxes.length;
      },

      /**
       * Initialiser le module.
       */
      init: function () {
        if (options === undefined) options = {};

        _this.containerSelector = options.containerSelector;
        if (_this.containerSelector === undefined) {
          console.error("The 'containerSelector' option MUST be set");
        }

        _this.tableSelector = options.tableSelector;
        if (_this.tableSelector === undefined) {
          console.error("The 'tableSelector' option MUST be set");
        }

        _this.selectedValuesInputSelector = options.selectedValuesInputSelector;
        _this.actionsSelector = options.actionsSelector;
        _this.pageCheckboxSelector = options.pageCheckboxSelector === undefined ? ".selector-page-elements-checkbox" : options.pageCheckboxSelector
        _this.elementCheckboxSelector = options.elementCheckboxSelector === undefined ? ".selector-element-checkbox" : options.elementCheckboxSelector
        _this.refreshChecked();
        _this.setupListeners();
      },

      /**
       * Rafraichir les checkboxes.
       */
      refreshChecked: function () {
        if (_this.selectedValuesInputSelector !== undefined) {
          let vals = $(_this.selectedValuesInputSelector).val();
          let parsed = JSON.parse(vals);
          for (const id of parsed) {
            _this.toggleRowCheckbox(id, true);
          }
        }
      },

      /**
       * Initialiser les listeners.
       */
      setupListeners: function () {

        let $container = $(_this.tableSelector);

        $container.on("change", _this.pageCheckboxSelector, function (ev) {
          let checked = ev.target.checked;
          _this.toggleAllCheckboxes(checked);
          _this.triggerEvent("change", {
            checkedValues: _this.checkedValues
          })
        });

        $container.on("change", _this.elementCheckboxSelector, function (ev) {
          let checked = ev.target.checked;
          let $row = $(this).closest("tr");
          let rowId = $row.attr("element-id");
          _this.toggleRowCheckbox(rowId, checked);
          _this.triggerEvent("change", {
            checkedValues: _this.checkedValues
          })
        });

      },

      /**
       * Cocher ou décocher tous les checkboxes de la table.
       * @param {boolean} checked 
       */
      toggleAllCheckboxes: function (checked) {
        let $checkboxes = $(_this.tableSelector).find(_this.elementCheckboxSelector);
        $checkboxes.each(function () {
          let rowId = $(this).closest("tr").attr("element-id");
          _this.toggleRowCheckbox(rowId, checked);
        })
      },

      /**
       * Cocher ou décocher un checkbox de la table.
       * @param {number} rowId 
       * @param {boolean} checked 
       */
      toggleRowCheckbox: function (rowId, checked) {
        let $checkbox = $(_this.tableSelector).find(`tr[element-id=${rowId}] ${_this.elementCheckboxSelector}`);
        $checkbox.prop("checked", checked);
        rowId = parseInt(rowId);
        _this.checkedValues = _this.checkedValues.filter(v => v !== rowId);
        if (checked) {
          _this.checkedValues.push(rowId);
        }

        let allchecked = _this.selectedInPageCount == _this.availableInPageCount;
        let $pageCheckbox = $(_this.tableSelector).find(_this.pageCheckboxSelector);
        $pageCheckbox.prop("checked", allchecked);

        if (_this.selectedValuesInputSelector !== undefined) {
          $(_this.selectedValuesInputSelector).val(JSON.stringify(_this.checkedValues))
        }
      },

      on: function (event, callback) {
        _this.events[event].push(callback);
        return _this;
      },

      off: function (event) {
        _this.events[event] = [];
        return _this;
      },

      triggerEvent: function (event, data) {
        let fullData = {
          instance: _this,
          data: data
        };
        let listeners = _this.events[event];
        for (const listener of listeners) {
          listener(fullData);
        }
      }

    }

    _this.init();

    return _this;
  }

  return {
    init: function (options) {
      return fct(options);
    }
  }

})();

window.ListMultiSelector = ListMultiSelector;

export default ListMultiSelector;